import { visibilityMap, boxSizingMap, allMap, overflowYMap, overflowXMap, overflowMap, displayMap } from '../../../mappers.mappings.js';

var layoutStyleMapper = {
  display: function display(value, _) {
    return {
      classNames: [displayMap[value]]
    };
  },
  overflow: function overflow(value, _) {
    return {
      classNames: [overflowMap[value]]
    };
  },
  overflowX: function overflowX(value, _) {
    return {
      classNames: [overflowXMap[value]]
    };
  },
  overflowY: function overflowY(value, _) {
    return {
      classNames: [overflowYMap[value]]
    };
  },
  all: function all(value, _) {
    return {
      classNames: [allMap[value]]
    };
  },
  boxSizing: function boxSizing(value, _) {
    return {
      classNames: [boxSizingMap[value]]
    };
  },
  visibility: function visibility(value, _) {
    return {
      classNames: [visibilityMap[value]]
    };
  }
};

export { layoutStyleMapper };
//# sourceMappingURL=layout.js.map
